<template>
    <div class="row">
        <div class="col-md-3">
            <div class="form-group">
                <label for="country">Country</label>
                <select name="CountryID" id="country" class="form-control" v-model="country_id"
                        @change="callStatesByCountryId()">
                    <option value="" selected>Select Country</option>
                    <option v-for="country in countries" :value="country.ID">{{ country.CountryName }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group">
                <label for="state">State</label>
                <select name="StateID" id="state" class="form-control" @change="callCitiesByStateID()" v-model="state_id">
                    <option v-for="state in states" :value="state.ID"> {{ state.StateName }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-group">
                <label for="city">City</label>
                <select name="CityID" id="city" class="form-control" v-model="city_id" @change="callAreaByCityID(city_id)">
                    <option value="0" disabled selected> Select City </option>
                    <option v-for="city in cities" :value="city.ID"> {{ city.CityName }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-3" v-if="isShowArea">
            <div class="form-group">
                <label for="area">Area</label>
                <select name="area_id" id="area" class="form-control" v-model="area_id">
                    <option value="0" disabled selected> Select Area </option>
                    <option v-for="area in areas" :value="area.ID"> {{ area.AreaName }}</option>
                </select>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'spot-search-filter',
        props: ['countries', 'isShowArea'],
        data(){
            return {
                base_url : "http://localhost/NaiZindagiMIS/ajax/",
                state_id: "",
                area_id: "",
                cities: null,
                states: null,
                areas: null,
                spots: null,
                errored: false,
                loading: false,
                city_id: "",
                spot_id: "",
                country_id: "",
                country: "",
            }
        },
        methods:{
            callStatesByCountryId(){
                axios.get('states/' + this.country_id)
                    .then(response => {
                        this.states = response.data
                    }).
                catch(error => {
                    console.log(error)
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            },
            callCitiesByStateID(){
                axios.get('cities/' + this.state_id)
                    .then(response => {
                        this.cities = response.data
                        console.log(this.cities);
                    }).
                catch(error => {
                    console.log(error)
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            },
            callAreaByCityID(city_id){

                axios.get('areas/' + city_id)
                    .then(response => {
                        this.areas = response.data
                        console.log(this.areas);
                    }).
                catch(error => {
                    console.log(error)
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            },
            callSpotByAreaID(area_id){
                console.log(area_id)
                axios.get('spots/' + area_id)
                    .then(response => {
                        this.spots = response.data
                        console.log(this.spots);
                    }).
                catch(error => {
                    console.log(error)
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            },
        },
        mounted() {
        }
    }
</script>
